import { BASE_PATH, PATH_BASE_EXTENSION_USER } from "../../utils/constants";
import { authFetch } from "../../utils/fetch";
import {getToken} from "../Auth/token";
import axios from "axios";

export async function tasksApi(data) {
   
    const url = `${BASE_PATH}${PATH_BASE_EXTENSION_USER}/calendar/tasks`;
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(url,  data ,config)
}

export async function getTaskApi(id) {
   
        const url = `${BASE_PATH}${PATH_BASE_EXTENSION_USER}/calendar/${id}`;
        const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
        return axios.get(url, config)
}

export async function startOrEndTaskApi(id) {
   
        const url = `${BASE_PATH}${PATH_BASE_EXTENSION_USER}/calendar/start-or-end-task/${id}`;
        const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
        return axios.get(url, config)

}